<template>
  <div class="home">
    <Navbar></Navbar>
      <Hero title="Excelencia en Iluminación" subtitle="A los mejores precios" clase="defaultHero"/>
      <Categorias></Categorias>

      
      

     

  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Categorias from "@/sections/Categorias.vue";

export default {
  name: "home",
  components: {
    Hero,Categorias
  }
};
</script>

<style>

</style>

